var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"socials"},_vm._l((_vm.socials),function(social){return _c('a',{key:social.name,class:social.name,attrs:{"href":social.url,"target":"blank"}},[_c('img',{attrs:{"height":"30","width":"30","src":`/images/icons/socials/${social.name}.svg`}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }